import { FSVersionEnum } from '../enums/FSVersionEnum';
import { InvoiceSendingTypeStringEnum } from '../enums/InvoiceSendingTypeString.enum';
import { SendingSessionStatusEnum } from '../enums/sendingSessionStatus.enum';

/* eslint-disable camelcase */
export enum NewspaperType {
  Any = -1,
  Regardless = 0,
  Newspaper1 = 1,
  Newspaper2 = 2,
  Newspaper3 = 3,
  Newspaper4 = 4,
  Newspaper5 = 5,
}

export enum MemberType {
  Unknown = -1,
  Active = 0,
  Interested = 1,
  Other = 2,
  All = 3,
  Resigned = 4,
}

export interface InvoiceMissionResponse {
  invoiceMission_id: number;
  owner_id?: number;
  missionName: string;
  date: string;
  source: FSVersionEnum;
  accountNr: string;
  formTemplate: string;
  selection: string;
  expireDateFrom: string;
  expireDateTom: string;
  profilesInclude: string;
  profilesExclude: string;
  newspaper?: NewspaperType;
  type: string;
  memberType?: MemberType;
  printZeroInvoice?: boolean;
  householdInvoice?: boolean;
  senderName: string;
  senderAddress: string;
  email: string;
  openMission?: boolean;
  template_id?: number;
  archived: boolean;
  missionSourceType: string;
  payIntervalFrom: number;
  payIntervalTom: number;
  approvePaymentsGreaterThanInvoiced?: boolean;
  data: InvoiceMissionData;
  dataList: InvoiceMissionDataList[];
  sendingSessions: SendingSession[];
  isApprovedByCustomer: boolean;
  sendingApprovalEmails?: string;
}

export interface InvoiceMissionData {
  emailCount: number;
  mobilePhoneCount: number;
  sendingType: string;
  totalCount: number;
  totalCountSent: number;
}

export interface InvoiceMissionDataList {
  emailCount: number;
  mobilePhoneCount: number;
  sendingType: string;
  totalCount: number;
  totalCountSent: number;
  isTemplateSendingValid: boolean;
  approval: InvoiceMissionApproval;
}

export interface SendingSession {
  createdAt: string;
  createdDate: string;
  deliveryMethod: string;
  sendingsCount: number;
  session_id: number;
  sign: string;
  type?: InvoiceSendingTypeStringEnum;
  status?: SendingSessionStatusEnum;
}

export interface InvoiceMissionApproval {
  id: number;
  invoiceMission_id: number;
  approvalRequired: boolean;
  approvedAt: string;
  approvedBy: string;
  createdAt: string;
  sendingType: InvoiceSendingTypeStringEnum;
  deniedAt: string;
  deniedBy: string;
  message: string;
  sndDate: string;
  deadline: string;
  createEndedAt: string;
  createStartedAt: string;
  sendEndedAt: string;
  sendStartedAt: string;
}
